import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { JobActionsUnion, JobActionTypes } from '@core/actions/job.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface JobsInfo {
    id: number;
    UserId: number;
    FollowId: number;
    type: string;
    metadata: Partial<JobMetadata>;
    createdAt: Date;
    updatedAt: Date;
}
  
export interface JobMetadata {
    status: string;
    totalProducts: number;
    totalImgs: number;
    urls: any[];
}


export interface State extends EntityState<JobsInfo> {
  loading: boolean;
  loaded: boolean;
  exporting: boolean;
  busy: boolean;
  spinnerMessage: string;
  allJobs: any;
}

export const adapter: EntityAdapter<JobsInfo> = createEntityAdapter<JobsInfo>({
  selectId: (job: JobsInfo) => job.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  exporting: false,
  busy: false,
  spinnerMessage: null,
  allJobs: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: JobActionsUnion
) {
  switch (action.type) {
    case JobActionTypes.GetJobsInfo:
        return {
          ...state,
          loading: true
        };

    case JobActionTypes.GetJobsInfoSuccess:
        return adapter.addAll(action.jobs, {
            ...state,
            loading: false,
            loaded: true,
            isBusy: false,
            allJobs: action.jobs
        });

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectExporting = (state: State) => state.exporting;
export const getState = createFeatureSelector<State>('jobs');
export const getAll = createSelector(
    getState,
    selectAll
);

export const getBusy = createSelector(
  getState,
  (state: State) => state.busy
);

export const getSpinnerMessage = createSelector(
  getState,
  (state: State) => state.spinnerMessage
);

export const getAllJobs = createSelector(
    getState,
    getAll
);
